import { types } from '../reducers/errorReducer';

export const reloadError = (items) => ({
  type: types.RELOAD,
  payload: items,
});

export const resetError = () => ({
  type: types.RESET,
});

export { getDraftId } from '../reducers/errorReducer';
